const sideloaded = window['__session__'] || {};
const channelSettings = window['ChannelSettings'] || {};

window['ChannelSettings'] = undefined;

let account = {};
// Grab account from profile or logged in user
if (sideloaded.profile) {
  account = sideloaded.profile;
}

export default {
  name: account.subdomain_name ? account.subdomain_name : false,
  defaultRecipient: account.default_recipient_email
    ? account.default_recipient_email
    : false,
  inboundTransferSizeLimit:
    channelSettings.inboundTransferSizeLimit > 2 * 1024 * 1024 * 1024
      ? channelSettings.inboundTransferSizeLimit
      : false,
};
